import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { TaskListComponent } from './task-list/task-list.component'
import { TaskScheduleComponent } from './task-schedule/task-schedule.component'
import { TaskCalendarComponent } from './task-calendar/task-calendar.component'
import { SharedModule } from '../shared/shared.module'
import { CoreModule } from '../core/core.module';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TaskScheduleCommentsComponent } from './task-schedule/task-schedule-comments/task-schedule-comments.component';
import { TaskEditComponent } from './task-edit/task-edit.component';
import { NgPipesModule } from 'ngx-pipes';
import { ReactiveComponentModule } from '@ngrx/component';
import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import { TaskRangePipe } from './task-list/task-range.pipe';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { DragDropModule } from '@angular/cdk/drag-drop';

@NgModule({
  declarations: [
    TaskListComponent,
    TaskScheduleComponent,
    TaskScheduleCommentsComponent,
    TaskEditComponent,
    TaskCalendarComponent,
    TaskRangePipe,
  ],
  exports: [
    TaskListComponent, 
    TaskScheduleComponent, 
    TaskScheduleCommentsComponent,
    TaskEditComponent
  ],
  imports: [
    CommonModule, 
    SharedModule, 
    CoreModule, 
    BrowserAnimationsModule, 
    FormsModule, 
    ReactiveFormsModule,
    NgPipesModule,
    ReactiveComponentModule,
    DragDropModule,
    BsDropdownModule.forRoot(),
    PaginationModule.forRoot(),
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
  ]
})
export class TaskModule { }
